
import Emitter from 'wolfy87-eventemitter';

const eventEmitter = new Emitter();

function addListener(name, listener) {

  eventEmitter.addListener(name, listener);
}

function removeListener(name, listener) {

  eventEmitter.removeListener(name, listener);
}

function emit(name, params) {

  eventEmitter.emit(name, params);
}

export default {

  addListener,
  emit,
  removeListener
};
